<!-- src/App.vue -->
<template>

  <div id="app">
    <button class="hamburger" @click="toggleMenu">
      ☰
    </button>

    <!-- Sidebar menu -->
    <div class="sidebar" :class="{ open: isOpen }">
      <router-link to="/CV" @click="closeMenu">About Me</router-link>
      <router-link to="/remoteOperation" @click="closeMenu">Remote Operation Dashboard</router-link>
    </div>

    <!-- Overlay -->
    <div class="overlay" v-if="isOpen" @click="closeMenu"></div>

    <!-- Main content -->
    <div class="main-content">
      <div class="content-wrapper">
        <router-view />
      </div>
    </div>
  </div>


  <!-- <div> -->
    <!-- <nav> -->
      <!-- <router-link to="/CV">CV</router-link> | -->
      <!-- <router-link to="/remoteOperation">remoteOperation</router-link> -->
    <!-- </nav> -->

    <!-- <hr /> -->

    <!-- <router-view /> -->
  <!-- </div> -->
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isOpen: false
    }
  }, 
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen
    },
    closeMenu() {
      this.isOpen = false
    }
  }
}
</script>

<style>
/* Layout */
#app {
  position: relative;
}

/* Hamburger button */
.hamburger {
  position: fixed;
  top: 1rem;
  left: 1rem;
  z-index: 1001;
  font-size: 1.5rem;
  background: none;
  border: none;
  color: black;
  cursor: pointer;
}

/* Sidebar */
.sidebar {
  position: fixed;
  top: 0;
  left: -220px;
  width: 200px;
  height: 100%;
  background: #333;
  padding-top: 60px;
  transition: left 0.3s ease;
  z-index: 1000;
}

.sidebar.open {
  left: 0;
}

.sidebar a {
  display: block;
  color: white;
  padding: 1rem;
  text-decoration: none;
}

.sidebar a:hover {
  background: #444;
}

/* Overlay */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.3);
  z-index: 900;
}

/* Main content wrapper */
.main-content {
  /* padding: 2rem; */
  display: flex;
  justify-content: center;
}

/* .content-wrapper {
  max-width: 1000px;
  width: 100%;
} */
</style>